import { render } from "./Stock_Adjustments.vue?vue&type=template&id=708377ba&scoped=true"
import script from "./Stock_Adjustments.vue?vue&type=script&lang=js"
export * from "./Stock_Adjustments.vue?vue&type=script&lang=js"

import "./Stock_Adjustments.vue?vue&type=style&index=0&id=708377ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-708377ba"]])

export default __exports__